import Glide from "@glidejs/glide";

document
  .querySelectorAll('.glide-products')
  .forEach((slider) => {
    if (slider) {
      const config = {
        perView: 4,
        focusAt: 0,
        gap:0,
        rewind: false,
        type: 'slider',
        breakpoints: {
          800: {
            perView: 2
          },
          480: {
            perView: 1
          }
        }
      };

      const CustomLength = function(Glide, Components, Events) {
        return {
          mount () {
            Events.emit('slider.length', Components)
          }
        }
      }
      
      let glide = new Glide(slider, config)
    
      glide.on('slider.length', (components) => {
        let control = components.Controls
        let length = components.Sizes.length

        if(length <= 4 && document.body.clientWidth > 480){
          glide.settings.dragDistance = false;
          glide.disable()
          control.items[0]?.classList.add('hidden')
        } else if (length <= 1 && document.body.clientWidth < 480) {
          control.items[0]?.classList.add('hidden')

          glide.disable()
        }
      })
      
      glide.mount({
        CustomLength
      })
    }
  } ) 